import { z } from "zod";
import { oc } from "@orpc/contract";
//#region src/api/orpc/attribution.ts
const identifiersInputSchema = z.object({
	anonymousId: z.string().uuid("Invalid UUID").optional(),
	idfa: z.string().max(64).regex(/^[0-9a-fA-F-]+$/, "Invalid device ID").optional(),
	googleAdvertisingId: z.string().max(64).regex(/^[0-9a-fA-F-]+$/, "Invalid device ID").optional(),
	facebookPixelId: z.string().max(128).regex(/^[A-Za-z0-9._-]+$/, "Invalid pixel ID").optional(),
	firebaseInstallationId: z.string().max(64).regex(/^[A-Za-z0-9_-]+$/, "Invalid installation ID").optional(),
	googleAnalyticsClientId: z.string().max(128).regex(/^[A-Za-z0-9._-]+$/, "Invalid client ID").optional()
}).refine((data) => Object.values(data).some((v) => typeof v === "string" && v.length > 0), { message: "At least one identifier must be provided" });
const identifiersOutputSchema = z.object({
	id: z.string(),
	idfa: z.string().nullable(),
	googleAdvertisingId: z.string().nullable(),
	facebookPixelId: z.string().nullable(),
	firebaseInstallationId: z.string().nullable(),
	googleAnalyticsClientId: z.string().nullable()
});
const clickEventInputSchema = z.object({
	anonymousId: z.string().uuid("Invalid UUID").optional(),
	source: z.string().max(64).regex(/^[a-z0-9_-]+$/, "Invalid source").optional(),
	gclid: z.string().max(256).regex(/^[A-Za-z0-9_-]+$/, "Invalid click ID").optional(),
	gbraid: z.string().max(256).regex(/^[A-Za-z0-9_-]+$/, "Invalid click ID").optional(),
	wbraid: z.string().max(256).regex(/^[A-Za-z0-9_-]+$/, "Invalid click ID").optional(),
	fbclid: z.string().max(256).regex(/^[A-Za-z0-9_-]+$/, "Invalid click ID").optional(),
	fbc: z.string().max(256).regex(/^[A-Za-z0-9._-]+$/, "Invalid cookie value").optional()
}).refine((data) => !!(data.gclid || data.gbraid || data.wbraid || data.fbclid || data.fbc), { message: "At least one attribution identifier (gclid, gbraid, wbraid, fbclid, fbc) must be provided" });
const clickEventOutputSchema = z.object({ id: z.string() });
const unauthorizedError = { UNAUTHORIZED: {
	status: 401,
	message: "Authentication required"
} };
const badRequestError = { BAD_REQUEST: {
	status: 400,
	message: "Bad request"
} };
const attributionContract = oc.prefix("/attribution").tag("Attribution").router({
	upsertIdentifiers: oc.route({
		summary: "Upsert device/browser identifiers",
		description: "Upserts device and browser identifiers for the current session. Requires authentication.",
		method: "POST",
		path: "/identifiers"
	}).input(identifiersInputSchema).output(identifiersOutputSchema).errors({
		...unauthorizedError,
		...badRequestError
	}),
	createClickEvent: oc.route({
		summary: "Record an ad click event",
		description: "Records an ad click event for attribution tracking. No authentication required.",
		method: "POST",
		path: "/click-events"
	}).input(clickEventInputSchema).output(clickEventOutputSchema)
});
//#endregion
export { attributionContract };
